module.exports = __webpack_public_path__ + "img/metro-icon.cf0b3c67.svg";